import { gql } from '@apollo/client';

export const GET_TENANT_BILLING = gql`
query getTenantBilling {
  orgRegionCode
  tm {
    tenant {
      billing {
        tenantBillingId
        packageOption {
          billingPackage {
            tier {
              name
              description
              volunteerLimit
              adminLimit
              programManagerLimit
            }
            tier {
              volunteerLimit
              adminLimit
              programManagerLimit
            }
            stripeProduct
          }
          stripePrice
        }
        customer
        cards
        subscription
        upcoming
        invoices
        complementaryAccount
        customPackage
      }
    }
  }
}
`;